// extracted by mini-css-extract-plugin
export default {"MarkdownTextViewer__Markdown":"MarkdownTextViewer_MarkdownTextViewer__Markdown__LwjEL"};